import StakingPage from "./single";
import { MenuNode, MenuRoute } from "../../components/menu";
import { ShellRouteNames } from "../shell/route-names";
import { Transition } from "@uirouter/react";
import { AllStakingContractsPage } from "./all";
import { And, LeafRole } from "../../utils/and-or-tree";

const names = {
  all: `${ShellRouteNames.shell}.staking`,
  single: `${ShellRouteNames.shell}.staking-single`,
};

const states: MenuRoute[] = [
  {
    name: names.single,
    url: "/staking/:address",
    views: {
      $default: {
        component: StakingPage,
      },
    },
    resolve: [
      {
        token: "address",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().address,
      },
    ],
    data: {
      title: "staking",
      roles: new LeafRole("ROLE_CRYPTO"),
    },
  },
  {
    name: names.all,
    url: "/rewards-program",
    views: {
      $default: {
        component: AllStakingContractsPage,
      },
    },
    data: {
      title: "rewards-program",
      roles: new LeafRole("ROLE_CRYPTO"),
    },
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "staking",
  route: states[1],
  roles: new And(new LeafRole("ROLE_CRYPTO"), new LeafRole("ROLE_USER")),
};

export const StakingRoutes = {
  names,
  states,
  sidebar,
};
